/** Loads cached Google Calendar events for an inclusive date range. */
import { useMemo } from 'react';
import { useGCal } from '@/features/planning/context/useGCal';

/**
 * @param {Date} startDate
 * @param {Date} endDate
 * @returns {object[]}
 */
export const useGCalEventsForRange = (startDate, endDate) => {
  const { isEnabled, getEventsForRange } = useGCal();
  const startMs = startDate instanceof Date ? startDate.getTime() : null;
  const endMs = endDate instanceof Date ? endDate.getTime() : null;

  return useMemo(() => {
    if (!isEnabled || startMs === null || endMs === null) return [];
    const rangeStart = new Date(startMs);
    rangeStart.setHours(0, 0, 0, 0);
    const rangeEnd = new Date(endMs);
    rangeEnd.setHours(23, 59, 59, 999);
    return getEventsForRange(rangeStart, rangeEnd) || [];
  }, [isEnabled, getEventsForRange, startMs, endMs]);
};
